import React from "react";
import { Container, Button } from "reactstrap";
import "./style.css";
import { Link } from "react-router-dom";

function HeaderParallax() {
  return (
    <div className="page-header section-dark headerParallax">
      <div className="filter" />
      <div className="content-center">
        <Container>
          <div className="title-brand">
            <div className="tc mainHeader">
              <h1 className="white tc i">
                <b>BECOME A CHAMPION AT WORK</b>{" "}
              </h1>

              <Link to={"/careers/jobs"}>
                <Button className="applyButtonMainScreen heartbeat">
                  Apply Now
                </Button>
              </Link>
            </div>
            {/* <h1 className="presentation-subtitle">
              <Typical
                steps={[
                  "I am ISSA Certified",
                  2000,
                  "I am a Fitness Trainer",
                  2000,
                  "I am a Bodybuilding Specialist",
                  2000,
                  "I am a weight loss specialist",
                  2000,
                ]}
                loop={Infinity}
                wrapper="h3"
              />
            </h1> */}
          </div>
        </Container>
      </div>
      {/* <div className="moving-clouds" /> */}
    </div>
  );
}

export default HeaderParallax;
